import { Component } from "react";
import { Button } from 'primereact/button';
import logoBranca from '../../../images/logoBranca.png';
import Constante from "../../../util/Constante";
import Util from "../../../util/Util";

export default class HeaderSistema extends Component {
  util = new Util();
  constante = new Constante();
  render() {
    return <header style={{ height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 10, backgroundColor: this.constante.corPrincipal, }}>

      <div style={{ height: 50, width: 100 }}>
        <img
          alt="Logo branca"
          src={logoBranca}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </div>


      <nav style={{ display: 'flex', alignItems: "center", gap: 10, }}>
        <Button
          style={{ color: this.constante.corSecundaria }}
          label="Profissionais"
          className="p-button-link"
          onClick={() => window.location.href = '/sistema/profissionais'} />
        <Button
          style={{ color: this.constante.corSecundaria }}
          label="Condomínio"
          className="p-button-link"
          onClick={() => window.location.href = '/sistema/condominio'} />

        <Button
          style={{ color: this.constante.corSecundaria }}
          label="Documento"
          className="p-button-link"
          onClick={() => window.location.href = '/sistema/documentos'} />

        <Button
          style={{ color: this.constante.corSecundaria }}
          label="Perfil"
          className="p-button-link"
          onClick={() => window.location.href = '/sistema/perfil'} />


        <Button
          style={{ color: this.constante.corSecundaria }}
          label="Sair"
          className="p-button-link"
          onClick={() => {
            this.util.removerLocalStorage("PESSOA_USUARIO");
            window.location.href = '/sistema/login';
          }} />
      </nav>
    </header>
  }
}